// https://stackoverflow.com/questions/1912501/unescape-html-entities-in-javascript

const STANDARD_HTML_ENTITIES = {
  nbsp: String.fromCharCode(160),
  amp: '&',
  quot: '"',
  lt: '<',
  gt: '>',
  slash: String.fromCharCode(0x2f),
}

export const decodeHtmlEntities = (plainTextString) => {
  if (!plainTextString || typeof plainTextString !== 'string')
    return plainTextString

  return plainTextString
    .replace(/&#([a-z0-9]+);/g, (match, dec) => String.fromCharCode(`0${dec}`))
    .replace(/&#([\d]+);/g, (match, dec) => String.fromCharCode(dec))
    .replace(
      /&(nbsp|amp|quot|lt|gt|slash);/g,
      (a, b) => STANDARD_HTML_ENTITIES[b]
    )
}
